import Action from '../../Action'
// import './styles/ModalDeleteUSer.css'
import { useState,useEffect } from 'react';
import LoadSimple from '../../LoadSimple';
import { capitalizeFirstLetter } from '../../../utils/utils';
// import './Maintenance-styles/ModalAddHost.css'
import { lang } from '../../generales/traduction';
import Search from '../../generales/Search';
import Paginador from '../../generales/Paginador';
const ModalHostListSync =({source,buscar_cis,server,languaje,handleShowPopup,mode,hosts,elementsList,SetElementList,setDataWorkFlow,dataWorkFlow,brand,closHostsListModal})=>{
  const [poolRows,setPoolRows]=useState([])
    const [allSelected, setAllSelected] = useState(false);
    // const [hostSelected,setHostSelected]=useState(hosts.filter(item => poolRows.includes(item.hostid)))
    const [contRowsSelected,setContRowSelected]=useState(0)
    const [searchResults, setSearchResults] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [limitList, setLimitList] = useState(50); 
  const [pageActual, setPageActual] = useState(1);
  const [searchResult, setSearchResult] = useState(null);
  const [response,setResponse]=useState([])

    var dataList = searchTerm === "" ? response : searchResults;
        // console.log(dataList)
    const startLimit = limitList * pageActual - limitList;
    const pages = parseInt(dataList.length / limitList) + 1;

    const [searchResults2, setSearchResults2] = useState([]);
    const [searchTerm2, setSearchTerm2] = useState("");
    const [limitList2, setLimitList2] = useState(50); 
  const [pageActual2, setPageActual2] = useState(1);
  const [searchResult2, setSearchResult2] = useState(null);
      const [responseDelete,setResponseDelete]=useState([])
       var dataList2 = searchTerm2 === "" ? responseDelete : searchResults2;
        // console.log(dataList2)
    const startLimit2 = limitList2 * pageActual2 - limitList2;
    const pages2 = parseInt(dataList2.length / limitList2) + 1;
    const [loadingM,setLoadingM]=useState(false);

  
    
    const handleSelectAll = () => {
        if (allSelected) {
          // Si ya está todo seleccionado, deselecciona todo
          setPoolRows([]);
        } else {
          setPoolRows(hosts.map(item => item.hostid))
        }
        setAllSelected(!allSelected); // Alterna el estado de seleccionar todo
      };
      const handleSearch = (query) => {
        setSearchResult(`Resultados para: ${query}`);
      };
      const handleSelectChange = (e) => {
        setPageActual(1)
        setLimitList(e.target.value);setPageActual(1);
      };
       const handleSelectChange2 = (e) => {
        setPageActual2(1)
        setLimitList2(e.target.value);setPageActual2(1);
      };
      /************************************************* */
      /************************************************* */
      /************************************************* */
      /*******************seleccionar host ************* */
      /************************************************* */
      /************************************************* */
      /************************************************* */
      const search_host_list_by_source=()=>{
       
       
        setLoadingM(true)
          const fetchDataPost = async () => {
           
         try {
           let urlSource=(source=='byGroupID')?'host_groups/hosts_list/'+brand.groupid:'hosts/byTemplateID/'+brand.templateid
           const response = await fetch(server.url+'/api/v1/cassia/workflow/resync/preview/'+brand.id, {
             method: 'GET',  
             headers: {
               'Content-Type': 'application/json',
               Authorization: `Bearer ${localStorage.getItem('access_token')}`,
             },
             // body:JSON.stringify(host_list)
           });
           if (response.ok) {
             const data1 = await response.json();
             setLoadingM(false)
             setResponse(data1.data.to_add)
             setResponseDelete(data1.data.to_delete)
             // buscar_cis()
             // handleShowPopup(capitalizeFirstLetter(lang[languaje]['completado']),capitalizeFirstLetter((lang[languaje]['regDeleteCorr'])),'', true)
             // closDeleteUserModal()

             // console.log(data1);
           } else {
             throw new Error('Error en la solicitud');
           }
         } catch (error) {
              // Manejo de errores
              handleShowPopup('Error!!!',capitalizeFirstLetter(lang[languaje]['regDeleteNoCorr']),capitalizeFirstLetter(lang[languaje]['reportError']), false)
              // setError(error)
              console.error(error);
            }
          };
      
          fetchDataPost();
          
    }
    useEffect(()=>{
      search_host_list_by_source()
    },[])
     const sync=()=>{
       
       
        setLoadingM(true)
          const fetchDataPost = async () => {
           
         try {
           let urlSource=(source=='byGroupID')?'host_groups/hosts_list/'+brand.groupid:'hosts/byTemplateID/'+brand.templateid
           const response = await fetch(server.url+'/api/v1/cassia/workflow/resync/'+brand.id, {
             method: 'POST',  
             headers: {
               'Content-Type': 'application/json',
               Authorization: `Bearer ${localStorage.getItem('access_token')}`,
             },
             // body:JSON.stringify(host_list)
           });
           if (response.ok) {
             const data1 = await response.json();
             setLoadingM(false)
             // setResponse(data1.data.to_add)
             // buscar_cis()
             buscar_cis()
             closHostsListModal()
             handleShowPopup(capitalizeFirstLetter(lang[languaje]['completado']),'Petición de sincronización exitosa','', true)
             // closDeleteUserModal()

             // console.log(data1);
           } else {
             throw new Error('Error en la solicitud');
           }
         } catch (error) {
              // Manejo de errores
              handleShowPopup('Error!!!',capitalizeFirstLetter(lang[languaje]['regDeleteNoCorr']),capitalizeFirstLetter(lang[languaje]['reportError']), false)
              // setError(error)
              console.error(error);
            }
          };
      
          fetchDataPost();
          
    }
    return(
        <>
        <div className="modal-GS-content">
        <div className='card-modal-gs modal-verificate'>
                <div className='head-card-modal-gs'>
                    <div className='title-head-card-modal-gs'>
                    Listado de dispositivos por Sincronizar: &nbsp;
                    </div>
                </div>
                <div className='content-card-modal-gs' style={{overflowY: 'scroll',scrollbarWidth: 'thin',display:'flex',height:'85%'}}>
                    <div className='half-content-card-modal-gs' style={{height:'90%'}}>
                    <>
   <div className='head-cis'>
    <div className='title-cis'>
                <Search
                    searchResults={searchResults}
                    setSearchResults={setSearchResults}
                    searchTerm={searchTerm}
                    setSearchTerm={setSearchTerm}
                    onSearch={handleSearch}
                    dataObject={response}
                    searchResult={searchResult}
                    setSearchResult={setSearchResult}
                    languaje={languaje}
                  />
          <div className={"cont-result-registers"+mode} style={{width:'25%',bottom:'0px'}}>
         
                  <p style={{  textAlign: "center" ,fontSize:'var(--font-size-xSmall)'}}>
                    &nbsp;
                    {capitalizeFirstLetter(lang[languaje]['resultadosEncontrados'])+" (" +
                      dataList.length +
                      ") " 
                      }
                  </p> 
          </div>
         
               
             
                </div>
                
            </div>
            <div className='cont-cis'>
            <>
      <div className="main-panel-cis">
      <div className="compact-content-portafolio">
      <div className={"content-portafolio-head"+mode}>
                      <div style={{fontSize:'var(--font-size-xSmall',width:'100%',height:'100%',display:'flex',justifyContent:'center',alignItems:'center',color:'var(--txt-color)'}}>
                       {'Dispositivos por agregar'}
                      </div>
              </div>
        <div className="content-portafolio">
          <div className="cont-portafolio-table">
            <div className="content-card-portafolio" id="content">
             
            <div className="cont-table-portafolio">
      <div className={"head-table-portafolio"+mode}>
      <div className="compact-head-table-portafolio">
      {/* <div className="field-head-table-mantenimiento field-medium">  <div className='cont-checkbox'>
                 <input type='checkbox' className='NotifiCheckBox ' checked={allSelected} style={{height:'15px'}} onChange={()=>console.log("all")}  onClick={()=>handleSelectAll()} ></input>
                </div></div> */}
        {/* <div className="field-head-table-mantenimiento field-small"> ID</div> */}
        <div className="field-head-table-mantenimiento field-medium" style={{width:'20%'}}>{'Host ID'}</div>
        <div className="field-head-table-mantenimiento field-larger" style={{width:'80%'}} >{capitalizeFirstLetter(lang[languaje]['dispositivo'])} </div>
        {/* <div className="field-head-table-mantenimiento field-larger" style={{width:'40%'}} >{capitalizeFirstLetter(lang[languaje]['marca'])} </div> */}
       
        </div>
      </div>
      <div className="body-table-portafolio">
       
      <>
      <div className="cont-row-user-list">
        {(
          loadingM?<div className="cont-load-user-list">
          <LoadSimple></LoadSimple>
        </div>:
          dataList
            .slice((dataList.length<limitList?0:startLimit), parseInt(pageActual) * parseInt(limitList))
            .map((elemento, indice) => (
              <div
                className={" row-table-portafolio"+mode }
                key={indice}
               
              >
                 
                {/* <div className="field-body-table-mantenimiento field-small">
                  {elemento.hostid}
                </div> */}
                <div className="field-body-table-mantenimiento field-larger" style={{width:'20%'}}>
                  {elemento.hostid}
                </div>
                <div className="field-body-table-mantenimiento field-larger" style={{width:'80%'}}>
                  {elemento.hostname}
                </div>
                {/* <div className="field-body-table-mantenimiento field-medium" style={{width:'40%'}}>
                  {elemento.model_name}
                </div>
                */}
                
                
               
              </div>
            ))
        )}
        { (response.length == 0 ) ? (
          <div className="no-results">{capitalizeFirstLetter(lang[languaje]['sinResultados'])}.</div>
        ) : (
          ""
        )}
      </div>
      
    </>
      </div>
    </div>
            </div>
          </div>

          </div>
          <div className={"content-portafolio-footer"+mode}>
          <div className="cont-display-paginador" style={{position: 'absolute',left: '0%',justifyContent: 'start'}}>
            
            {/* <div className={"cont-half-display-paginador"+mode}>
            <p style={{  textAlign: "center" }}>
                            &nbsp;
                            {(contRowsSelected!=0)?"("+contRowsSelected+")  "+capitalizeFirstLetter(lang[languaje]['registosSeleccionados']):''}
                      </p> 
                  
            </div> */}
          </div>  
          <div className="cont-display-paginador" style={{width:'60%'}}>
                    <Paginador  pages={pages}
                                pageActual={pageActual}
                                setPageActual={setPageActual}
                                mode={mode}></Paginador>
          </div>
          <div className="cont-display-paginador" style={{width:'50%'}}>
            <div className={"cont-half-display-paginador"+mode}>
                      
            <div>
      <label htmlFor="selector">{capitalizeFirstLetter(lang[languaje]['filasPagina'])}: </label>
      <select id="selector" value={limitList} className="pageSelector" onChange={handleSelectChange}>
        <option value={10}>10</option>
        <option value={50} >50</option>
        <option value={100}>100</option>
        <option value={500}>500</option>
        <option value={1000}>1000</option>
      </select>

      
    </div>
            </div>
            <div className={"cont-half-display-paginador"+mode} >
            <p style={{  textAlign: "center" ,fontSize:'var(--font-size-xSmall) !important'}}>
                            &nbsp;
                            {"(" +
                        (startLimit + 1) +
                        " - " +
                        (dataList.length > parseInt(pageActual ) * parseInt(limitList)
                          ? parseInt(pageActual ) * parseInt(limitList)
                          : dataList.length) +
                        ")  "+lang[languaje]['de']+" " +
                        dataList.length +
                        " "+lang[languaje]['resultados']}
                      </p>
                      {/* {"(" +
                        (startLimit + 1) +
                        " - " +
                        (dataList.length >  parseInt(pageActual ) * parseInt(limitList)
                          ?  parseInt(pageActual ) * parseInt(limitList)
                          : dataList.length) +
                        ")  "+lang[languaje]['de']+" " +
                        dataList.length +
                        " "+lang[languaje]['resultados']} */}
            </div>
          </div>  
                    
        </div>
        </div>
      </div>
      
    </>
                
            </div>
   </>
      
                    </div>
                    {/* <div className='contentButtomsWorkflow'>
                    <div className="form-GS-box"> 
                    <div className="user-box-GS" style={{height:'100%'}}>
                                        {
                                            (false)?<LoadSimple></LoadSimple>
                                            :
                                            <>
                                            <Action disabled={false} origen='Azul' titulo={'Sincronzar'}  action={()=>{sync()}}/>
                                            <Action disabled={false} origen='Cancelar' titulo={capitalizeFirstLetter(lang[languaje]['cancelar'])}  action={closHostsListModal}/>
                                            </>
                                            // <Action disabled={disabled} origen='Login' titulo='Guardar'  action={Registrar}/>
                                        }
                                            
                                    {
                                        // (registerIsValid && data.message!=="User deleted successfully")?<span className='form-msg-ok'>Usuario registrado correctamente</span>:''
                                    }
                                        
                                    </div>
                                    </div>
                    </div> */}
                     <div className='half-content-card-modal-gs' style={{height:'90%'}}>
                    <>
   <div className='head-cis'>
    <div className='title-cis'>
                <Search
                    searchResults={searchResults2}
                    setSearchResults={setSearchResults2}
                    searchTerm={searchTerm2}
                    setSearchTerm={setSearchTerm2}
                    onSearch={handleSearch}
                    dataObject={responseDelete}
                    searchResult={searchResult2}
                    setSearchResult={setSearchResult2}
                    languaje={languaje}
                  />
          <div className={"cont-result-registers"+mode} style={{width:'25%',bottom:'0px'}}>
         
                  <p style={{  textAlign: "center" ,fontSize:'var(--font-size-xSmall)'}}>
                    &nbsp;
                    {capitalizeFirstLetter(lang[languaje]['resultadosEncontrados'])+" (" +
                      dataList2.length +
                      ") " 
                      }
                  </p> 
          </div>
         
               
             
                </div>
                
            </div>
            <div className='cont-cis'>
            <>
      <div className="main-panel-cis">
      <div className="compact-content-portafolio">
      <div className={"content-portafolio-head"+mode}>
                      <div style={{fontSize:'var(--font-size-xSmall',width:'100%',height:'100%',display:'flex',justifyContent:'center',alignItems:'center',color:'var(--txt-color)'}}>
                       {'Dispositivos por eliminar'}
                      </div>
              </div>
        <div className="content-portafolio">
          <div className="cont-portafolio-table">
            <div className="content-card-portafolio" id="content">
             
            <div className="cont-table-portafolio">
      <div className={"head-table-portafolio"+mode} style={{background:'var(--error-color)'}}>
      <div className="compact-head-table-portafolio">
      {/* <div className="field-head-table-mantenimiento field-medium">  <div className='cont-checkbox'>
                 <input type='checkbox' className='NotifiCheckBox ' checked={allSelected} style={{height:'15px'}} onChange={()=>console.log("all")}  onClick={()=>handleSelectAll()} ></input>
                </div></div> */}
        {/* <div className="field-head-table-mantenimiento field-small"> ID</div> */}
        <div className="field-head-table-mantenimiento field-medium" style={{width:'20%'}}>{'Host ID'}</div>
        <div className="field-head-table-mantenimiento field-larger" style={{width:'80%'}} >{capitalizeFirstLetter(lang[languaje]['dispositivo'])} </div>
        {/* <div className="field-head-table-mantenimiento field-larger" style={{width:'40%'}} >{capitalizeFirstLetter(lang[languaje]['marca'])} </div> */}
       
        </div>
      </div>
      <div className="body-table-portafolio">
       
      <>
      <div className="cont-row-user-list">
        {(
          loadingM?<div className="cont-load-user-list">
          <LoadSimple></LoadSimple>
        </div>:
          dataList2
            .slice((dataList2.length<limitList2?0:startLimit2), parseInt(pageActual2) * parseInt(limitList2))
            .map((elemento, indice) => (
              <div
                className={" row-table-portafolio"+mode }
                key={indice}
               
              >
                 
                {/* <div className="field-body-table-mantenimiento field-small">
                  {elemento.hostid}
                </div> */}
                <div className="field-body-table-mantenimiento field-larger" style={{width:'20%'}}>
                  {elemento.hostid}
                </div>
                <div className="field-body-table-mantenimiento field-larger" style={{width:'80%'}}>
                  {elemento.hostname}
                </div>
                {/* <div className="field-body-table-mantenimiento field-medium" style={{width:'40%'}}>
                  {elemento.model_name}
                </div>
                */}
                
                
               
              </div>
            ))
        )}
        { (responseDelete.length == 0 ) ? (
          <div className="no-results">{capitalizeFirstLetter(lang[languaje]['sinResultados'])}.</div>
        ) : (
          ""
        )}
      </div>
      
    </>
      </div>
    </div>
            </div>
          </div>

          </div>
          <div className={"content-portafolio-footer"+mode}>
          <div className="cont-display-paginador" style={{position: 'absolute',left: '0%',justifyContent: 'start'}}>
            
            {/* <div className={"cont-half-display-paginador"+mode}>
            <p style={{  textAlign: "center" }}>
                            &nbsp;
                            {(contRowsSelected!=0)?"("+contRowsSelected+")  "+capitalizeFirstLetter(lang[languaje]['registosSeleccionados']):''}
                      </p> 
                  
            </div> */}
          </div>  
          <div className="cont-display-paginador" style={{width:'60%'}}>
                    <Paginador  pages={pages2}
                                pageActual={pageActual2}
                                setPageActual={setPageActual2}
                                mode={mode}></Paginador>
          </div>
          <div className="cont-display-paginador" style={{width:'50%'}}>
            <div className={"cont-half-display-paginador"+mode}>
                      
            <div>
      <label htmlFor="selector">{capitalizeFirstLetter(lang[languaje]['filasPagina'])}: </label>
      <select id="selector" value={limitList2} className="pageSelector" onChange={handleSelectChange2}>
        <option value={10}>10</option>
        <option value={50} >50</option>
        <option value={100}>100</option>
        <option value={500}>500</option>
        <option value={1000}>1000</option>
      </select>

      
    </div>
            </div>
            <div className={"cont-half-display-paginador"+mode} >
            <p style={{  textAlign: "center" ,fontSize:'var(--font-size-xSmall) !important'}}>
                            &nbsp;
                            {"(" +
                        (startLimit2 + 1) +
                        " - " +
                        (dataList2.length > parseInt(pageActual2 ) * parseInt(limitList2)
                          ? parseInt(pageActual2 ) * parseInt(limitList2)
                          : dataList2.length) +
                        ")  "+lang[languaje]['de']+" " +
                        dataList2.length +
                        " "+lang[languaje]['resultados']}
                      </p>
                      {/* {"(" +
                        (startLimit + 1) +
                        " - " +
                        (dataList.length >  parseInt(pageActual ) * parseInt(limitList)
                          ?  parseInt(pageActual ) * parseInt(limitList)
                          : dataList.length) +
                        ")  "+lang[languaje]['de']+" " +
                        dataList.length +
                        " "+lang[languaje]['resultados']} */}
            </div>
          </div>  
                    
        </div>
        </div>
      </div>
      
    </>
                
            </div>
   </>
      
                    </div>
                    
                </div>
                 <div className='contentButtomsWorkflow'>
                    <div className="form-GS-box"> 
                    <div className="user-box-GS" style={{height:'100%'}}>
                                        {
                                            (false)?<LoadSimple></LoadSimple>
                                            :
                                            <>
                                            <Action disabled={false} origen='Azul' titulo={'Sincronzar'}  action={()=>{sync()}}/>
                                            <Action disabled={false} origen='Cancelar' titulo={capitalizeFirstLetter(lang[languaje]['cancelar'])}  action={closHostsListModal}/>
                                            </>
                                            // <Action disabled={disabled} origen='Login' titulo='Guardar'  action={Registrar}/>
                                        }
                                            
                                    {
                                        // (registerIsValid && data.message!=="User deleted successfully")?<span className='form-msg-ok'>Usuario registrado correctamente</span>:''
                                    }
                                        
                                    </div>
                                    </div>
                    </div>
            </div>
            
            </div>
           
        </>
    )
}

export default ModalHostListSync